var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacetime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 125",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 0c14.843 0 26.875 12.033 26.875 26.875v71.25c0 14.843-12.032 26.875-26.875 26.875H26.875C12.033 125 0 112.968 0 98.125v-71.25C0 12.033 12.033 0 26.875 0H112.5Zm84.882 9.877A11.25 11.25 0 0 1 200 17.093v91.492c0 6.213-5.037 11.25-11.25 11.25a11.25 11.25 0 0 1-7.122-2.542l-32.5-26.58A11.25 11.25 0 0 1 145 82.005V44.252a11.25 11.25 0 0 1 4.036-8.632l32.5-27.16c4.767-3.985 11.862-3.35 15.846 1.418Z",
    fill: "#0abb28",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacetime);
export default __webpack_public_path__ + "static/media/facetime.d9f6e4e858e9a4365daca12b5763fa2e.svg";
export { ForwardRef as ReactComponent };